<template>
  <v-dialog
    max-width="1000"
    value="visible"
  >
    <v-card class="card-modal">
      <div class="d-flex justify-end px-5 pt-5 pb-2">
        <v-btn
          icon
          @click="$emit('on-results-requote-modal-close')"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <v-container class="pb-10">
        <h6 class="text-h6 mb-5">How It Works</h6>
        <ol
          start="1"
          type="1"
          class="list mb-5"
        >
          <li class="mb-3">
            Create an account or complete a quote and sign up
          </li>
          <li class="mb-3">
            We’ll save your details for reference
          </li>
          <li class="mb-3">
            Head back to {{ partnerText }} and we’ll display your cheapest quote price on the cars you are thinking of buying
          </li>
        </ol>
        <p class="mb-5">
          As you view different cars on site you can quickly request an insurance quote without filling in another form. Less time filling in forms gives you more time to find your new ride.
        </p>
        <h6
          v-if="carSalesPrice"
          class="text-h6 mb-5"
        >
          Save up to &pound;{{ salePrice.toFixed() }}*
        </h6>
        <p
          v-if="carSalesPrice"
          class="mb-5"
        >
          Customers can save up to &pound;{{ salePrice.toFixed(2) }}* on their car insurance when comparing and buying through Quotezone.
        </p>
        <div class="d-flex justify-center mb-5">
          <a :href="redirectUrl">
            <v-btn
              rounded
              color="success"
            >
              <span>Return to {{ partnerText }}</span>
            </v-btn>
          </a>
        </div>
        <p
          v-if="carSalesText"
          class="text-body-2"
          v-html="carSalesText"
        />
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'results-requote-modal',
  props: {
    redirectUrl: {
      type: String,
      default: '',
    },
    partnerText: {
      type: String,
      default: '',
    },
    carSalesPrice: {
      type: Number,
      default: 0,
    },
    carSalesText: {
      type: String,
      default: '',
    },
  },
  computed: {
    salePrice () {
      const salePrice = Number(this.carSalesPrice);
      return isNaN(salePrice) ? 0 : salePrice;
    },
  },
};
</script>

<styles scoped lang="scss">
.list {
  list-style: auto;
 }

.card-modal {
  font-family: 'Source Sans Pro';
}
</styles>
